export default "__VITE_ASSET__CQYHLHQl__"